import axios from "axios";
import store from "@/store";

const http = axios.create({
  baseURL: `${process.env.VUE_APP_API_URL}/v1`,
  headers: {
    "Content-type": "application/json",
  },
  withCredentials: true,
});

http.interceptors.request.use(
  (config) => {
    if (shouldLoad(config)) {
      store.commit("loading/startLoading");
    }
    return config;
  },
  (error) => {
    store.commit("loading/stopLoading");
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  (response) => {
    store.commit("loading/stopLoading");
    return response;
  },
  (error) => {
    store.commit("loading/stopLoading");
    return Promise.reject(error);
  }
);

function shouldLoad(config) {
  // let dontLoadLikesAndUnlikes = !config.url.includes("like");
  // return dontLoadLikesAndUnlikes;
  return false;
}

function isMobile() {
  return screen.width < 768;
}

export default http;
